import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle2, Users, Globe } from 'lucide-react';
import { Card } from './ui/card';

const Hero = () => {
  const stats = [
    { icon: CheckCircle2, value: '25+', label: 'Projects Delivered', color: 'text-cyan-600' },
    { icon: Users, value: '25+', label: 'Happy Clients', color: 'text-cyan-600' },
    { icon: Users, value: '34+', label: 'Team Members', color: 'text-cyan-600' },
    { icon: Globe, value: '7+', label: 'Countries Served', color: 'text-cyan-600' },
  ];

  const scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = (e) => {
    e.preventDefault();
    const servicesSection = document.querySelector('#services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-gradient-to-b from-cyan-50 to-white py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Hero Content */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Empowering Businesses Through Digital Innovation
          </h1>
          <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto font-semibold">
            Adidar Tech India Pvt. Ltd. is a trusted technology partner delivering AI, Cloud Computing, Software Development, IT Infrastructure, Database Services, Cybersecurity, and Digital Transformation solutions that help businesses innovate, scale, and succeed.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={scrollToContact}
              className="bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-6 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              Get Started
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              onClick={scrollToServices}
              variant="outline" 
              className="border-2 border-cyan-600 text-cyan-600 hover:bg-cyan-50 px-8 py-6 text-lg rounded-lg transition-all duration-300 cursor-pointer"
            >
              Our Services
            </Button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <Card 
                key={stat.label} 
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-0"
              >
                <div className="flex flex-col items-center text-center">
                  <Icon className={`w-12 h-12 ${stat.color} mb-4`} />
                  <div className="text-4xl font-bold text-gray-900 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-gray-600 text-sm">
                    {stat.label}
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;